import { render, staticRenderFns } from "./UnboxSpinner.vue?vue&type=template&id=787978d0&scoped=true"
import script from "./UnboxSpinner.vue?vue&type=script&lang=js"
export * from "./UnboxSpinner.vue?vue&type=script&lang=js"
import style0 from "./UnboxSpinner.vue?vue&type=style&index=0&id=787978d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787978d0",
  null
  
)

export default component.exports